import { QueryClient } from '@tanstack/react-query';

/**
 * The assistant's OWN query client.
 *
 * ---------------------------------------------------------------------------
 * WHY THE MODULE OWNS A CLIENT
 * ---------------------------------------------------------------------------
 * The console has no application-wide `QueryClientProvider` yet, and the assistant
 * must not impose a cache policy on the rest of the console to get one. So the
 * module keeps its own client and provides it around the panel's own subtree.
 *
 * When the console grows a shared provider, this file is the one place that
 * changes: the provider is hoisted, and this client is either adopted or deleted.
 *
 * ---------------------------------------------------------------------------
 * WHY RETRIES ARE OFF
 * ---------------------------------------------------------------------------
 * A turn is a question to a model, not a write. A retried turn costs a second
 * answer, and a retried read on a refusal (`ai.assistant.configuration_required`)
 * would keep asking a question the server has already answered. Both read and
 * write failures are shown to the person instead.
 */
export const assistantQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
    },
    mutations: {
      retry: false,
    },
  },
});
